import { Dayjs } from 'dayjs';

export const getActiveWeek = (date: Dayjs) => {
  if (date.day() > 0) {
    return date.subtract(date.day() - 1, 'days').toDate();
  }
  return date.toDate();
};
